import React, { useState } from 'react'

interface SearchProps {
    onSearch: (value: string) => void
    placeholder: string
    autosuggest?: boolean
}

const Search: React.FC<SearchProps> = ({
    onSearch,
    placeholder,
    autosuggest,
}) => {
    const [searchValue, setSearchValue] = useState<string>('')

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
        if (autosuggest) {
            onSearch(e.target.value)
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearch(searchValue)
        }
    }

    const handleSearchClick = () => {
        onSearch(searchValue)
    }

    return (
        <div className="input-group search">
            <input
                type="text"
                className="form-control"
                placeholder={placeholder || 'Search'}
                aria-label="Search"
                value={searchValue}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
            />
            <span
                className="input-group-text"
                onClick={handleSearchClick}
                style={{ cursor: 'pointer' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                </svg>
            </span>
        </div>
    )
}

export default Search
